import {MenuItemActionBase} from "../menu-item-action-base";
import {IMenuItemExecuteOptions} from "../menu-item-action.interface";
import {IMenuItemConfigReader} from "../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";

export default class PushNotificationsPermissionsRequestAction extends MenuItemActionBase {
    constructor(configReader: IMenuItemConfigReader, services: IServiceFactoryExtended) {
        super("pushNotificationsPermissionsRequest", configReader, services)
    }

    protected async _onClick(options?: IMenuItemExecuteOptions): Promise<void> {
        this.services.sdk.promptPushNotificationPermissionRequest();
    }
}